import React from "react";
import HousingInfo from "./HousingInfo";

interface HousingProps {
  housingTypes: any;
  housingStates: any;
  housingOwnerships: any;
  form: any;
}

const HousingData = ({
  housingTypes,
  housingStates,
  housingOwnerships,
  form,
}: HousingProps) => {
  return (
    <div className="takaful--recipient-container">
      <HousingInfo
        housingTypes={housingTypes}
        housingStates={housingStates}
        housingOwnerships={housingOwnerships}
        form={form}
      />
    </div>
  );
};

export default HousingData;
